
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class POSReturnDialog extends _Ext.DialogBase<POSReturnRow, any> {

        protected getFormKey() { return POSReturnForm.formKey; }
        protected getIdProperty() { return POSReturnRow.idProperty; }
        protected getLocalTextPrefix() { return POSReturnRow.localTextPrefix; }
        protected getNameProperty() { return POSReturnRow.nameProperty; }
        protected getService() { return POSReturnService.baseUrl; }
        protected getDeletePermission() { return POSReturnRow.deletePermission; }
        protected getInsertPermission() { return POSReturnRow.insertPermission; }
        protected getUpdatePermission() { return POSReturnRow.updatePermission; }
        protected useViewMode() { return true; }
        public form = new POSReturnForm(this.idPrefix); 
        TaxArray: any[]; 
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number; 
        //ProdctImage of Items 
        static image: string;
        constructor() {
            super();
            //Make grid full width
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initDetailEditor(this, this.form.ItemDetails, Config);

            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.TaxDetails);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.TaxAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            q.setGridEditorHeight(this.form.TaxDetails, 150);
            //To Hide Image Toolbar & Label
            q.hideImageToolbar(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ProductItemImage);
            //q.hideCaption(this.form.Posted);
            //To Show Image on Right Top & Hide Categories
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryTwoColumn(this.form.ProductItemImage);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.TaxDetails);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);
            q.hideEditorLabel(this.form.CustomerName);

            this.form.TaxDetails.getGridField().find('.grid-toolbar').attr("style", "display:none;");
            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });


            // **** Get Party Details using PartyID **** 
            this.form.PartyId.changeSelect2(e => {

                let PartyDetails;
                OMS.VendorService.Retrieve({
                    EntityId: this.form.PartyId.value
                }, response => {
                    PartyDetails = response.Entity
                }, { async: false });
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value.toString());
                this.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                this.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                this.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                this.StoneDiscount = PartyDetails.StnAddDisc == null ? 0 : PartyDetails.StnAddDisc;
                this.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                this.LaborDiscount = PartyDetails.LbrAddDisc == null ? 0 : PartyDetails.LbrAddDisc;
                this.ExchangeRate = this.form.ExchRate.value; this.form.TaxId.value = PartyDetails.GstVat;
                //let AddressDetails = OMS.AddressMasterRow.getLookup().items.filter(x => x.LedgerId == parseInt(this.form.PartyId.value))[0];
                //if (AddressDetails != null) {
                //    this.form.State.value = OMS.StatesMasterRow.getLookup().itemById[AddressDetails.State].StateName;
                //    this.form.Country.value = OMS.CountriesMasterRow.getLookup().itemById[AddressDetails.Country].Name;

                //    var city = OMS.CitiesMasterRow.getLookup().itemById[AddressDetails.City].Name;
                //    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                //        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                //    this.form.Address1.value = address;

                //}
                this.form.GrossAmount.value = 0;

            });
            q.setTextRightAlign(this.form.RoundOff);
            this.form.RoundOff.changeSelect2(e => {
                this.form.GrossAmount.value = this.form.GrossAmount.value + this.form.RoundOff.value;
            });
            this.form.POSCustomerId.changeSelect2(e => {
                var cid = this.form.POSCustomerId.value;
                if (cid != "") {
                    let CustomerDetails: OMS.PosCustomerMasterRow
                    OMS.PosCustomerMasterService.Retrieve({ EntityId: cid }, response => { CustomerDetails = response.Entity }, { async: false });
                    this.form.ItemDetails.PartyId = parseInt(this.form.POSCustomerId.value.toString());
                    var fname = CustomerDetails.FirstName == null ? "" : CustomerDetails.FirstName;
                    var lname = CustomerDetails.LastName == null ? "" : CustomerDetails.LastName;
                    this.form.CustomerName.value = fname+' ' + lname;

                    this.form.POSCustomerId.value = CustomerDetails.POSCustomerId.toString();
                    this.form.Address.value = CustomerDetails.Address;
                    this.form.BirthDate.value = CustomerDetails.BirthDate;
                    this.form.Anniversary.value = CustomerDetails.Anniversary;
                    //this.form.Mobile.value = CustomerDetails.Mobile;
                    this.form.PanNumber.value = CustomerDetails.PanNumber;
                    this.form.TaxId.value = CustomerDetails.TaxId;
                }
            });

            this.form.CurrencyId.changeSelect2(e => {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            });

           
            //Load Image after Row in Details is Clicked
            var _this = this;
            this.form.ItemDetails.slickGrid.onClick.subscribe(function (e, args) {

                var x: Serenity.UploadedFile = {
                    Filename: POSReturnDialog.image,
                    OriginalName: ""
                }
                _this.form.ProductItemImage.value = x;//POSSalesDialog.image;

                //Set Image Width & Height

                q.setImageEditorHeight(_this.form.ProductItemImage, 160);
            });

            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;
            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getTotalRows();
                if (ItemTotal > 0) {
                    ItemTotal = 0;
                }

                this.CalculateAmountandTax(Items, TotalItems);
             

            })

            this.form.GrossAmount.addValidationRule(this.uniqueName, e => {
                //Validate Sales Item is Added or not
                if (this.form.ItemDetails.getItems().length == 0) {
                    Q.notifyWarning('No Sales Items Selected to Return')
                    return ""
                }
            });
            this.validateForm();
        } 
        public CalculateAmountandTax(Items: any, TotalItems: number) {

            var HSN = [];
            var Amount = [];
            var TaxDetail = [];
            var ItemTotal = 0;
            var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var wt = 0; var nwt = 0; var tds = 0;

            for (var x of Items) {
                ntamt += x.NetAmount || 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;
                pcs += x.Pieces || 0;
                wt += x.Weight || 0;
                nwt += x.NetWeight || 0;

                var temp = false;
                for (let i = 0; i < HSN.length; i++) {
                    if (HSN[i] == x.TaxCode) {
                        Amount[i] += x.GrossAmount || 0;
                        temp = true;
                    }
                }

                if (!temp) {
                    HSN.push(x.TaxCode);
                    Amount.push(x.GrossAmount);
                }
                ItemTotal++;
            };

            this.form.NetAmount.value = gramt;
            this.form.Discount.value = disc;

            var TaxAmount = 0;

            var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.form.VoucherTypeId.value)[0].IsTaxApplicable;

            if (ItemTotal == TotalItems && TaxApplicable) {

                var TaxItems = this.form.TaxDetails.getItems().length;
                var it = this.form.TaxDetails.getItems();
                if (TaxItems > 0) {
                    this.form.TaxDetails.DeleteTax();
                }

                //TODO: Get Company Country to Call appropriate TAX Helper

                TaxDetail = TaxHelper.NewTaxCalculation(HSN, Amount, this.form.TransDate.value, false, 0);
                //Get Taxes for Voucher
                TaxDetail = TaxHelper.VoucherTaxCalculation(this.form.VoucherTypeId.value, gramt, this.form.TransDate.value, TaxDetail, false);


                var temp2 = this.form.TaxDetails.getData(TaxDetail);
                this.form.TaxDetails.view.setItems(temp2, true);

                TaxDetail.forEach(function (value) {
                    if (value.TaxType != "TDS")
                        TaxAmount += value.TaxAmount;
                    else
                        tds += value.TaxAmount;

                });

                this.form.TaxAmount.value = TaxAmount;
                this.form.GrossAmount.value = gramt + TaxAmount;
                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;
            }
            else {
                this.form.GrossAmount.value = gramt - disc;
                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;
            }
        } 
        protected onDialogOpen() {
            super.onDialogOpen();
             

            if (this.form.POSCustomerId.value != "") {
                //let PartyDetails = OMS.VendorRow.getLookup().itemById[this.form.PartyId.value];
                this.form.ItemDetails.PartyId = parseInt(this.form.POSCustomerId.value);

                var items = this.form.ItemDetails.getItems();
                let pieces = [];
                let weight = [];
                let itemids = [];
                items.forEach(function (value) {
                    itemids.push(value.TransItemId);
                    pieces.push(value.Pieces);
                    weight.push(value.Weight);
                }); 
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, true);

            }
            else {

                this.form.GrossAmount.value = 0; 
            } 

            var fieldEditor: JQuery = this.form.POSCustomerId.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $('<a><b/>...</a>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
        }

        protected inplaceSearchClick(e: any): void {
            var grid = OMS.PosCustomerMasterGrid;
            var pickerDialog = new _Ext.GridItemPickerDialog({
                gridType: grid, multiple: false, title: "Select Customer"
            });

            pickerDialog.onSuccess = (selectedItems: OMS.PosCustomerMasterRow[]) => {

                this.form.POSCustomerId.value = selectedItems[0].POSCustomerId.toString();
                this.form.CustomerName.value = selectedItems[0].FirstName + " " + selectedItems[0].LastName;
                this.form.Address.value = selectedItems[0].Address;
                this.form.BirthDate.value = selectedItems[0].BirthDate;
                this.form.Anniversary.value = selectedItems[0].Anniversary;
                //  this.form.Mobile.value = selectedItems[0].Mobile;
                this.form.PanNumber.value = selectedItems[0].PanNumber;
                this.form.TaxId.value = selectedItems[0].TaxId;
            }
            pickerDialog.dialogOpen();

        }
        

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                reportKey: 'Retail.POSReturnVoucher',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));


            var postingpermission = Q.Authorization.hasPermission('Retail:POSReturn:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;
                 
                    POSReturnService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });

            
            return btns;
        }

        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                POSReturnService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }
        validateBeforeSave() {
            let Isvalid = super.validateBeforeSave();
            Isvalid = ValidateTransaction(this.form.ItemDetails.getItems(), this.form.Pieces.value, this.form.Weight.value);
            return Isvalid;
        }
     }
}